












import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { BlogFilter, BlogOrderBy } from 'client-website-ts-library/filters';
import { WebsiteLevel } from 'client-website-ts-library/types';

import Blogs from '../components/Blogs.vue';

@Component({
  components: {
    Blogs,
  },
})
export default class Blog extends Mixins(View) {
  private filter = new BlogFilter({
    SearchLevel: WebsiteLevel.Office,
    SearchGuid: 'f9d229bb-51ff-4b83-94eb-4877c1c736d2',
    OrderByStatements: [BlogOrderBy.CreateDateDesc],
  });
}
